import { makeStyles } from '@mui/styles'
import React from 'react'

import GlobalSearch from '@/modules/layout/components/menu/overlay/globalSearch'
import ThemeInterface from '@/theme-interface'
import DrawerWithOffset from '@/components/drawers/drawer-with-offset'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  wrapper: {
    maxWidth: '100%',
    background: theme.mode.backgroundColor.default,
    borderTop: `1px solid ${theme.mode.borderColor.light}`,
  },
  content: {
    padding: 0,
  },
}), { name: 'SearchDrawer' })

const SearchDrawer = (props) => {
  const { open, onClose } = props
  const classes = useStyles()
  const styles = {
    wrapper: classes.wrapper,
    children: classes.content,
  }

  return (
    <DrawerWithOffset
      anchor='left'
      open={open}
      styles={styles}
      dataQsId='searchDrawer-drawerWithOffset'
      onClose={onClose}>
      <GlobalSearch />
    </DrawerWithOffset>
  )
}

export default SearchDrawer
